import { Reducer } from 'redux';
import { DrawerState, DrawerTypes } from './types';

const INITIAL_STATE: DrawerState = {
  open: false,
};

const reducer: Reducer<DrawerState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES DRAWER
    case DrawerTypes.SET_TOGGLE_DRAWER:
      return {
        ...state,
        open: action.payload.open,
      };

    default:
      return state;
  }
};

export default reducer;
